import {useIsFetching} from "react-query";
import {useShowUI} from "../../services/common";

const LoadingBar = ({global, isLoading}) => {
	const isGlobalLoading = useIsFetching();
	const showUI = useShowUI();

	if(global) {
		isLoading = isGlobalLoading;
	}

	return isLoading && showUI ? (<span>Loading...</span>) : null;
}

export default LoadingBar;
